import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { computed, reactive, watch, ref } from "vue";
export default {
  props: ["questionInfo", "allAnswers"],
  setup(props, content) {
    //本题id
    let questionId = ref("");
    //草稿
    let draft = reactive({});
    //处理题目
    let itemText = computed(() => {
      let text = props.questionInfo.itemText;
      return text;
    });
    //答案
    let answer = reactive({});
    watch(props, () => {
      let list = {};
      //题目id
      questionId.value = props.questionInfo.questionGroupList[0].questionList[0].questionId;
      //草稿
      if (window.localStorage.getItem("draft")) {
        Object.assign(draft, JSON.parse(window.localStorage.getItem("draft")));
      } else {
        draft[questionId] = "";
      }
      props.questionInfo.questionGroupList.forEach(questionGroup => {
        questionGroup.questionList.forEach(questionItem => {
          questionId.value = questionItem.questionId;
          list[questionItem.questionId] = props.allAnswers && props.allAnswers[questionItem.questionId] ? props.allAnswers[questionItem.questionId] : "";
        });
      });
      Object.assign(answer, list);
    }, {
      immediate: true
    });
    //更换题目
    watch(() => props.questionInfo, () => {
      document.getElementsByClassName("question-text")[0].scrollTop = 0;
      document.getElementsByClassName("answer")[0].scrollTop = 0;
    });
    function setAnswer() {
      content.emit("setAnswer", answer);
    }
    function setDraft() {
      window.localStorage.setItem("draft", JSON.stringify(draft));
    }
    let wordsNo = computed(() => {
      let text = answer[questionId.value] ? answer[questionId.value] : "";
      text = text.replace(/\n/g, " ").replace(/,/g, " ").replace(/\./g, " ").replace(/\?/g, " ").replace(/!/g, " ").replace(/~/g, " ").replace(/"/g, " ").replace(/‘/g, " ").replace(/>/g, " ").replace(/</g, " ").trim().split(" ");
      let no = 0;
      text.forEach(item => {
        if (item.length > 0) {
          no++;
        }
      });
      return no;
    });
    return {
      wordsNo,
      itemText,
      answer,
      setAnswer,
      questionId,
      setDraft,
      draft
    };
  }
};